import { H3 } from "common/text";
import styled from "styled-components";

export const StyledSection = styled.div`
  margin-bottom: 40px;
`;
export const StyledDiv = styled.div`
  background-color: #d4e9ff;
  padding: 20px 20px 0 20px;
  max-width: 100%;
  overflowx: hidden;
`;

export const StyledParagraph = styled.p`
  font-size: 18px;
`;

export const StyledH4 = styled(H3)`
  text-transform: uppercase;
  margin-bottom: 10px;

  span {
    display: block;
    text-transform: capitalize;
    font-size: 30px;

    @media only screen and (min-width: 768px) {
      font-size: 25px;
    }

    @media only screen and (min-width: 1200px) {
      font-size: 30px;
    }
  }
`;

export const StyledImage = styled.img`
  width: 100%;
  height: 75%;
  bottom: -20px;
  margin-top: 20px;
  transform: scale(1.5);
  transform: translateY(18px);

  @media only screen and (min-width: 375px) {
    transform: translateY(25px);
  }

  @media only screen and (min-width: 768px) {
    width: 100%;
    height: 100%;
    margin-top: 0px;
    transform: scale(1);
    transform: translateY(14px);
  }

  @media only screen and (min-width: 992px) {
    transform: translateY(7px);
  }

  @media only screen and (min-width: 1200px) {
    transform: translateY(10px);
  }
`;

export const Copy = styled.div`
  border: 1.5px solid rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 5px 5px 10px;
  height: 50px;

  @media only screen and (min-width: 768px) {
    min-width: 30px;
  }
`;

export const CopyText = styled.p`
  display: inline-block;
  color: rgba(0, 0, 0, 0.5);
  align-self: center;
  margin: 0;
  margin-right: 10px;
  font-size: 16px;
  overflow: hidden;
`;

export const CopyButton = styled.button`
  border: none;
  background-color: #fdd440;
  color: #1070b6;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 18px;
  padding: 5px 10px;
  cursor: pointer;
`;

export const SmallShareButton = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  width: 60px;
  margin-right: 20px;
  border-radius: 2px;
  color: #fff;
  margin-top: 20px;
  cursor: pointer;

  @media only screen and (min-width: 770px) {
    margin-top: 0;
  }

  @media only screen and (min-width: 1020px) {
    margin-right: 10px;
    width: 50px;
  }

  @media only screen and (min-width: 1430px) {
    margin-right: 20px;
    width: 60px;
  }
`;

export const BigShareButton = styled.span`
  height: 50px;
  width: 220px;
  margin-right: 20px;
  border-radius: 2px;
  color: #fff;
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 16px;
  padding-left: 20px;
  padding-right: 20px;
  margin-top: 20px;
  cursor: pointer;
  @media only screen and (min-width: 770px) {
    margin-top: 0;
  }

  @media only screen and (min-width: 1020px) {
    margin-top: 20px;
  }

  @media only screen and (min-width: 1430px) {
    margin-top: 0;
  }
`;
